import { Component, EventEmitter, ViewChild, ElementRef, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { showPopupPost, groupSelector, showemotes, showtag } from './animations';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';

import { AppUpload } from '../../app.upload';
import { UserService } from '../../services/user.service';
import { SocialService } from '../../services/social.service';
import { StoreService } from '../../services/store.service';
import { environment } from '../../environment';

import { Item } from '../../models/item';
import { Post } from '../../models/post';
import { Friend } from '../../models/friend';
import { Account } from '../../models/account';
import { Product } from '../../models/product';
import { Reaction } from '../../models/reaction';
import { Character } from '../../models/character';
import { SocialChannel } from '../../models/channel';
import { Interaction } from '../../models/interaction';
import { Notification } from '../../models/notification';

@Component({
  selector: 'social',
  templateUrl: './social.community.html',
  providers: [ UserService, SocialService, StoreService, AppUpload ],
  animations: [
  	showtag,
  	showemotes,
  	groupSelector,
  	showPopupPost,
	trigger('flyInOut', [
		state('in', style({height: '330px', transform: 'translateX(0)', opacity: 1})),
		transition('void => *', [
			style({ transform: 'translateY(50px)', opacity: 0}),
			group([
				animate('0.3s 0.1s ease', style({
					transform: 'translateY(0)',
				})),
				animate('0.3s ease', style({
					opacity: 1
				}))
			])
		]),
		transition('* => void', [
			group([
				animate('0.3s ease', style({
					transform: 'translateY(50px)',
					opacity: 0
				}))
			])
		])
	])
  ]

})


export class SocialComponent implements OnInit {

	@ViewChild('NewPost') NewPost:ElementRef;
	
	newPostHeight = 'auto';
	newPostWidth = 'auto';

	emote: any;
	emotes: any;
	title: string;
	popupPost = -1;
	emoteTimer: any;
	subtitle: string;
	searching: boolean;
	friendcount: number;
	showEmotes: boolean;
	selectedChannel: any;
	selectedCharacter: any;
	
	showTag = false;
	channelSelector = false;
	characterSelector = false;

	searchResultsItem: Item;
	searchResultsAccount: Friend;
	searchResultsProduct: Product;


	profile: Account;
	accounts: Account;
	requests: Account;
	tagpeople: Friend;
	interactions: Interaction;
	notifications: Notification;
	character: Character;
	characters: Character;
	channels: SocialChannel;
	reactions: Reaction;

	comment = new Comment('', 0);

	post = new Publish('');
	tag = new Search('');
	feed: Post;
	
	constructor(private user: UserService,
				private store: StoreService,
				private social: SocialService,
				private sanitizer: DomSanitizer,
				private router: Router,
				private route: ActivatedRoute,
				private files: AppUpload,
				private cookie: CookieService) {
		this.emotes = [ 'smile', 'grin', 'tongue', 'sad', 'wink', 'dream', 'shocked', 'neutral', 'happy-grin', 'cool', 'mad', 'grin-evil', 'evil', 'wow', 'annoyed', 'wondering', 'confused', 'zipped', 'grumpy', 'mustache' ];
	}


	addEmotion( emotion ) {
		this.post.body = this.post.body + ' ['+emotion+'] ';
		this.showEmotes = (this.showEmotes==true) ? false : this.showEmotes;
	}

	hoverEmotes(i = 0) {
		this.emote = this.emotes[i];
		this.emoteTimer = setTimeout( () => {
			this.hoverEmotes(i++);
		}, 300);
	}

	unhoverEmotes() {
		clearInterval( this.emoteTimer );
	}

	

	/**
	 * Get public post feed and account details for the selected identity
	**/

	getFeed(user?) {
		Promise.resolve( this.social.feed(user) ).then((posts) => {
			this.feed = posts;
		});
	}


	commenting(e, p) {
		var code = (e.keyCode ? e.keyCode : e.which);
		if( code == 13 ) {
			Promise.resolve( this.social.newComment( p.postid, this.comment.body ) ).then( (result) => {
				this.getFeed();
				this.comment.body = '';
			});
		}
	}

	postMessage() {
		if ( this.post.body != '' ) {
			Promise.resolve( this.social.newPost(this.post.body, this.selectedChannel) ).then( (result) => {
				this.getFeed();
				this.post.body = '';
			});
		}
	}

	selectChannel(channel) {
		this.selectedChannel = channel;
	}


	removePost(id) {
		Promise.resolve(this.social.removePost(id)).then( (result) => {
			this.getFeed();
		});
	} 


	/** 
	 * Fetch Notifications
	**/

	getNotifications() {
		Promise.resolve(this.social.getNotifications()).then( (result) => {

		});
	}

	getFriendRequests() {
		Promise.resolve(this.social.getRequests()).then( (result) => {

		});
	}


	/**
	 * Add or Remove Friends
	**/ 
	confirmFriend(username) {
		Promise.resolve(this.social.updateFriend(username, true)).then((result) => {
			
		});
	}

	ignoreFriend(username) {
		Promise.resolve(this.social.updateFriend(username, false)).then((result) => {
			
		});
	}


	searchTag( $e ) {

		this.user.search(this.tag.search)
			.subscribe(results => {
				this.searchResultsItem = results[0];
				this.searchResultsProduct = results[1];
				this.searchResultsAccount = results[2];
		  	});

		this.searching = true;
		if ( !this.tag.search ) this.searching = false;

	}


	/**
	 * Get Public Groups
	**/
	
	publicGroups() {
		Promise.resolve(this.social.groupFeed()).then((result) => {
			
		});
	}


	
	viewUser(user) {
		Promise.resolve(this.user.getProfile(user)).then((profile) => {
			if ( profile ) {
				this.profile = profile;
				this.title = profile[0].username;
				this.subtitle = profile[0].subtitle;
			}
		});
	}

	activityFeed() {
		Promise.resolve(this.social.activityFeed()).then((result) => {
			
		});
	}

	getInteractions() {
		Promise.resolve(this.social.loadInteractions()).then((result) => {
			this.interactions = result;
		});
	}

	addInteraction( reaction, article ) {
		console.log(reaction, article);
	}



	/**
	* Get social media channels
	**/ 

	getCharacters() {
		Promise.resolve( this.user.loadUsersCharacters() ).then( ( chars ) => {
			if ( chars ) this.characters = chars;
		});
	}

	getCharacter() {
		Promise.resolve( this.user.selectedCharacter() ).then( ( char ) => {
			if ( char ) this.character = char;
		});
	}


	/**
	* Get social media channels
	**/ 

	getChans() {
		Promise.resolve( this.social.loadSocialChannels() ).then( ( chans ) => {
			if ( chans ) {
				this.channels = chans;
				this.selectedChannel = chans[0].name;
			}
		});
	}
	
	joinChan( chanID ) {
		Promise.resolve( this.social.joinChannel(chanID) ).then( ( chans ) => {
			console.log( chans );
		});
	}

	leaveChan( chanID ) {
		Promise.resolve( this.social.leaveChannel(chanID) ).then( ( chans ) => {
			console.log( chans );
		});
	}


	composeMessage(textbox) {

		var maxrows = 5,
			txt = this.NewPost.nativeElement.value,
			cols = this.NewPost.nativeElement.cols,
			row = this.NewPost.nativeElement.rows,
			arraytxt = txt.split('\n');
		
		var rows = arraytxt.length; 

		for ( var i = 0; i < arraytxt.length; i++ ) {

			// rows += parseInt( arraytxt[i].length / cols );

			// if (rows > maxrows) {
			// 	row = maxrows;
			// } else {
			// 	row = rows;
			// }

		}
	}

	/**
	 * Authorize your own identity
	**/

	authorize() {
		// Authorize a user
		this.user.authorizeUser().subscribe(acc => {
			this.accounts = acc;
			this.title = this.accounts[0].username;
			this.subtitle = this.accounts[0].subtitle;
		})
	}

	removeComment(comment) {
		Promise.resolve( this.social.removeComment( comment.id ) ).then( ( like ) => {
			this.getFeed();
			console.log( like );
		});
	}

	likeComment(comment, reaction = 'like') {
		Promise.resolve( this.social.reactToComment( reaction, comment.postid ) ).then( ( like ) => {
			console.log( like );
		});
	}

	like(post, reaction = 'like') {
		Promise.resolve( this.social.react( reaction, post.postid ) ).then( ( like ) => {
			console.log( like );
		});
	}

	share(post) {
		Promise.resolve( this.social.share( post.postid ) ).then( ( share ) => {
			console.log( share );
		});
	}

	getReactions() {
		Promise.resolve( this.social.reactions() ).then( ( all_reactions ) => {
			this.reactions = all_reactions;
		});
	}


	/**
	 * Initalize App
	**/

	/* On with the show */
	ngOnInit() {
		
		let username = this.route.snapshot.params['username'];
		if ( username ) this.viewUser(username);

		this.authorize();
		this.getFeed();
		this.getChans();
		this.getCharacters();
		this.getReactions();

		this.hoverEmotes(0);

	}

}

// This constructor generates the Post form
export class Publish {
  constructor(
	public body: string,
  ) {}
}

// This constructor generates the Comment form
export class Comment {
  constructor(
	public body: string,
	public postID: number,
  ) {}
}

// This constructor generates the Tag Search form
export class Search {
  constructor(
    public search?: string
  ) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/community/social.component.ts